import React, { useCallback } from "react";
import { Button } from "@trailhead/asurion-ui";
import { ButtonType } from "../../types";

import { useNavigate } from "@trailhead/core-ui";
import { trackEvent } from "@trailhead/analytics";

type Props = ButtonType & {
    openInNewTab?: boolean;
};

export const CardRedirectBtn = (props: Props): JSX.Element => {
    const { text, link, eventName, openInNewTab } = props;
    const navigateTo = useNavigate();

    const onClickRedirect = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        if (!!eventName) {
            trackEvent(eventName || "", {
                goTo: link,
            });
        }
        if (openInNewTab) {
            window.open(link || "", "_blank")?.focus();
            return;
        }
        navigateTo(link || "");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Button size="small" color="secondary" variant="outline" onClick={(event) => onClickRedirect(event)}>
            {text}
        </Button>
    )
}
